// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { AuthenticationType } from '../AuthenticationType';
import { AuthenticationResponseType } from '../AuthenticationResponseType';
import { AuthenticationResponseResult } from '../AuthenticationResponseResult';
import { UUID } from '@shared/utils/UUID';
export class VelocityAuthenticationService {
    constructor(loginUrl, logoutUrl, clientId) {
        this._scopes = 'openid+email';
        this._responseType = 'code';
        this._loginUrl = loginUrl;
        this._logoutUrl = logoutUrl;
        this._clientId = clientId;
    }
    get type() {
        return AuthenticationType.Velocity;
    }
    // #region IAuthenticationAutoLoginService
    processAutoLogin() {
        const search = window.location.search;
        if (isValidString(search) && search.includes('autologin')) {
            this.processLogin();
            return true;
        }
        return false;
    }
    // #endregion
    // #region IAuthenticationLoginButtonService
    get buttonText() {
        const text = 'Login with Velocity';
        return text;
    }
    processLogin() {
        window.location.href = this.getLoginAddress();
    }
    // #endregion
    // #region IAuthenticationLoginLinkService
    get loginLinkText() {
        const text = 'Logout with Velocity';
        return text;
    }
    processLoginLink() {
        window.location.href = this.getLogoutAddress();
    }
    // #endregion
    // #region IAuthenticationLoginTokenService
    isInputMode() {
        return true;
    }
    processToken() {
        const search = window.location.search;
        if (!isValidString(search)) {
            return new AuthenticationResponseResult(AuthenticationResponseType.Error, '');
        }
        const queryParams = new URLSearchParams(search);
        const error = queryParams.get('error');
        const errorDescription = queryParams.get('error_description');
        if (isValidString(error)) {
            return new AuthenticationResponseResult(AuthenticationResponseType.Error, `${error}: ${errorDescription}`);
        }
        const code = queryParams.get('code');
        if (isValidString(code)) {
            return new AuthenticationResponseResult(AuthenticationResponseType.Success, code);
        }
        else {
            return new AuthenticationResponseResult(AuthenticationResponseType.Error, '');
        }
    }
    processConnectionData(connectionData, token) {
        connectionData.login = '';
        connectionData.TokenID = token;
        connectionData.ExternalResourse = this.type;
    }
    processLoginRejection(code) {
        return false;
    }
    // #endregion
    // #region Helper functions
    getLoginAddress() {
        return `${this._loginUrl}client_id=${this._clientId}&redirect_uri=${encodeURIComponent(this.getCurrenntUrl())}&scope=${this._scopes}&response_type=${this._responseType}&state=${UUID.generateUUIDv5()}`;
    }
    getLogoutAddress() {
        return `${this._logoutUrl}client_id=${this._clientId}&redirect_uri=${encodeURIComponent(this.getCurrenntUrl())}`;
    }
    getCurrenntUrl() {
        let currentUrl = window.location.origin;
        if (currentUrl.charAt(currentUrl.length - 1) === '/') {
            currentUrl = currentUrl.slice(0, -1);
        }
        return currentUrl;
    }
}
